import '@angular/localize/init';
export * from './lib/feature-tax-muma-list.module';

export * from './lib/tax-muma-list/feature-tax-muma-list.component';
